import Reflux from "reflux";
import { singletonActions } from "logic/singleton";
const QueryValidationActions = singletonActions(
  "views.QueryValidation",
  () => Reflux.createActions({
    displayValidationErrors: {
      asyncResult: false
    }
  })
);
export default QueryValidationActions;
